export const passwordSymbols = '!@#$%^&*()-_+=:;"<>,.?/[ ]{}|\\`~'

export const hasSymbolCheck = (password: null | string) =>
  /* eslint-disable-next-line no-useless-escape */
  Boolean(password?.match(/[!@#$%^&*()_+=:;"<>,.`~[?{}|\-\/\]\\]/g))
export const hasNumberCheck = (password: null | string) => Boolean(password?.match(/\d/g))
export const hasLowerCaseCheck = (password: null | string) => Boolean(password?.match(/[a-z]/g))
export const hasUpperCaseCheck = (password: null | string) => Boolean(password?.match(/[A-Z]/g))
export const hasMinLengthCheck = (password: null | string) =>
  Boolean(!!password ? password.length > 7 : false)
